/* global confirm */
import { scrollTop } from 'utils/wrappers';

import FulfillmentOrders from 'app/collections/fulfillment_orders';
import FulfillmentOrderReport from 'app/models/fulfillment_order_report';
import Paginator from 'app/models/paginator';
import DateRange from 'app/models/date_range';
import Base from 'app/views/base';
import PaginationView from 'app/views/pagination_view';
import ApiModeToggle from 'app/views/api_mode_toggle';
import DatepickerRangeView from 'app/views/datepicker_range_view';
import RequestReportView from 'app/views/request_report_view';

import { List as ListView, Heading } from 'app/components/list/list';
import ListSearchView from 'app/components/list/search';
import { DetailBlock } from 'app/components/list/item_details';

import tmpl from './template';

const STATUS_MAP = {
  created: 'Created',
  preparing: 'Preparing Shipment',
  shipped: 'Shipped',
};

const PAGE_SIZE = 10;

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_orders',

  initialize() {
    this.dateRange = new DateRange({});
    this.collection = new FulfillmentOrders([], { dateRange: this.dateRange, apiMode: this.model });
    this.paginator = new Paginator({
      collection: this.collection,
      pageSize: PAGE_SIZE,
      buildParams() {
        return {
          limit: PAGE_SIZE,
          page: this.get('currentPage'),
          offset: this.get('currentPage') * PAGE_SIZE,
        };
      }
    });

    this.listenTo(this.collection, 'sync', scrollTop);
    this.listenTo(this.collection, 'update', this.render);

    const headings = [
      new Heading({
        property: 'id',
        display: 'Id',
        xsSize: 6,
        smSize: 6,
      }),
      new Heading({
        text: m => STATUS_MAP[m.get('status')],
        display: 'Status',
        xsSize: 2,
        smSize: 2,
        wrapperClass: s => s ? `order-status__${s.get('status')}` : '',
      }),
      new Heading({
        display: '',
        property: 'status',
        text: 'Cancel',
        onClick: this.cancelOrder.bind(this),
        wrapperClass: s => (
          s ? 'order-cancel-button' + (s.get('status') === 'created' ? '' : ' order-cancel-button__hidden') : ''
        ),
        xsSize: 2,
        smSize: 2
      }),
    ];

    this.addSubview('orderList', '#order_list', new ListView({
      headings,
      collection: this.collection,
      user: this.user,
      noResultsMessage: 'No orders found matching your filter set.',
      showDetails: {
        mainHeading: m => m.get('id'),
        detailBlocks: [
          new DetailBlock({
            heading: 'Status',
            items:  m => [ m.get('status') ],
          }),
          new DetailBlock({
            heading: 'Destination',
            items: m => m.addressArray(),
          }),
          new DetailBlock({
            heading: 'Phone',
            items: m => [ m.get('destination').phone ],
          }),
          new DetailBlock({
            heading: 'Tracking Codes',
            items: m => {
              return m.get('tracking_codes').map(t => t);
              // this will require an api call to get the real tracking url, TODO fix later
              //t => `<a href="https://track.easypost.com/${t}" target="_blank">${t}</a>`).join('<br />'),
            },
          }),
        ],
      },
    }));

    this.addSubview('pagination', '#order_pagination', new PaginationView({ model: this.paginator }));
    this.addSubview('apiModeToggle', '#api_mode_toggle', new ApiModeToggle({ model: this.model }));
    this.addSubview('datepickers', '#order_daterange_pickers', new DatepickerRangeView({ model: this.dateRange }));

    this.addSubview('requestReport', '#request_report', new RequestReportView({
      collection: this.collection,
      ReportClass: FulfillmentOrderReport,
      dateRange: this.dateRange,
      apiMode: this.model,
    }));

    this.addSubview('search', '#order_search', new ListSearchView({
      collection: this.collection,
      placeholder: '(Order Id or Tracking Code)',
    }));
  },

  cancelOrder(order) {
    if (order.get('status') !== 'created') { return; }

    if (confirm(`Are you sure you want to delete order #${order.get('id')}? To retrieve it, you will need to contact customer service.`)) {
      this.collection.remove(order);
      order.destroy();
    }
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_orders/index.js